var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.actions.length > 0)?_c('ul',{staticClass:"headerNavigation"},_vm._l((_vm.actions),function(item,index){return _c('li',{key:index,staticClass:"item"},[_c('router-link',{class:['items-navig', item.isActive() ? 'active-item' : ''],attrs:{"to":item.href}},[_vm._v(_vm._s(item.label))])],1)})):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dbef29ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/generics/Navigation.vue
// module id = 82cd
// module chunks = 15